<template>
  <main v-if="ready">
    <mfa-renew-pin />
  </main>
</template>

<script>
export default {
  metaInfo: {
    title: 'เปลี่ยนรหัสพิน'
  },
  data() {
    return {
      ready: false
    }
  },
  mounted() {
    const script = document.createElement('script')
    script.src = process.env.VUE_APP_MFA_SCRIPT_SOURCE
    script.onload = () => {
      window.mfa.init({ endpoint: '/api/mfa', source: 'oauth', homeURL: process?.env?.VUE_APP_FINNO_ENDPOINT })
      this.ready = true
    }

    script.onerror = e => {
      this.$router.push({
        path: '/internal-error',
        query: { error: encodeURIComponent(e.message || 'เกิดข้อผิดพลาด') }
      })
    }

    document.body.appendChild(script)
  }
}
</script>
